import styled from 'styled-components';
import { orange } from '../tokens';

// Unstyled <button type="button"> — the base every clickable composite in
// Forms extends (`styled(PlainButton)`), so pages never declare a raw
// styled.button. It resets the browser chrome (border, background, padding,
// font, colour, alignment) and keeps a visible orange focus halo for
// keyboard users only (:focus-visible). Props and refs pass straight through
// to the <button>; pass `type="submit"` explicitly when it submits a form.
const PlainButton = styled.button.attrs((p) => ({ type: p.type || 'button' }))`
  appearance: none;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-align: inherit;
  line-height: inherit;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px ${orange(0.45)};
  }

  &:disabled {
    cursor: default;
  }
`;

PlainButton.displayName = 'PlainButton';

export default PlainButton;
